import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6h2t8wux5r: FaireBrandEntity = {
  token: "b_6h2t8wux5r",
  type: "brand",
  name: "Bluecorn Candles",
  avatarUrl:
    "https://cdn.faire.com/fastly/acf6cdc2a86e80f558e8a27af77c4e5d7ba9a983d15ac3841b7f61d3ecdd2abf.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/12152685fd66e826d95c57100a2cd89334b9dbb959fe8e7670bfe3ef15d35a92.png",
  logoUrl:
    "https://cdn.faire.com/fastly/acf6cdc2a86e80f558e8a27af77c4e5d7ba9a983d15ac3841b7f61d3ecdd2abf.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/12152685fd66e826d95c57100a2cd89334b9dbb959fe8e7670bfe3ef15d35a92.png",
  location: "Montrose, CO, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 147,
  isTopShop: true,
  isInsider: true,
  description:
    "Bluecorn is a candle company dedicated to simplicity. For us, that means using pure, simple ingredients to build a product that helps us live richer, more connected lives. It's important to know, however, that underlying our sweet, simple candles is a complex process requiring an unwavering attention to detail and ultimately, a high level of craftsmanship.\n\nIn this way, we emulate the bees that bless us with all of their remarkable gifts. Their journey carries them across countless miles finding flowers, collecting pollen and making wax — the building block of their exquisite homes.\n\nOur journey begins with sourcing only the finest of this beeswax, then lightly filtering it to remove particulates while leaving the sweet scent and vibrant color intact. Then, we painstakingly test burn every batch and carefully choose the right wick to ensure a perfect burn.\n\nYes, we keep it simple, but we work really hard at it.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:41.021Z",
    importedBy: "entity-db-cli",
  },
};
